import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "../components/site/Seo";
import { PageHeader } from "../components/site/Section";
import { Reveal } from "../components/site/Reveal";
import { SERVICES } from "../data/site";
import useHashScroll from "../hooks/useHashScroll";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export default function Services() {
  useHashScroll();
  return (
    <div data-testid="services-page">
      <Seo title="Services" description="Direct hire, executive search, staffing, RPO, managed workforce services, workforce planning, and human capital consulting from VectorBridge Group LLC." />
      <PageHeader
        label="S/01"
        kicker="Capabilities"
        title="The full spectrum of workforce solutions."
        intro="Twelve integrated services spanning talent acquisition, contingent workforce management, and human capital advisory — deployed individually or as a coordinated program."
      />

      <section className="border-b border-border">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <div className="grid border-l border-border sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <Reveal key={s.id} id={slugify(s.title)} delay={(i % 3) * 0.05} className="group scroll-mt-28 border-b border-r border-border p-8 transition-colors hover:bg-secondary target:bg-secondary">
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs text-brand">{s.id}</span>
                  <ArrowUpRight size={18} className="text-muted-foreground transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
                </div>
                <h3 className="mt-12 font-display text-2xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-border bg-secondary">
        <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-6 px-5 py-16 sm:flex-row sm:items-center sm:px-8">
          <h2 className="max-w-xl font-display text-3xl font-light tracking-tighter sm:text-4xl">Need a tailored program? We design engagements around your mission.</h2>
          <Link to="/contact" data-testid="services-cta" className="group inline-flex shrink-0 items-center gap-2 bg-brand px-6 py-4 font-mono text-xs uppercase tracking-[0.15em] text-white transition-colors hover:bg-navy">
            Request a consultation <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </section>
    </div>
  );
}
